import * as React from 'react';
import { ThemeBgSensitive } from '@mentimeter/ragnar-ui/themes';
import { useQuestion, useTheme } from '../../data-mediation';
import { ControlsWrapper } from '../ControlsWrapper';
import { Controls } from './index';

export const SlideControls = () => {
  const { background_color } = useTheme();
  const { theme_settings } = useQuestion();
  const themeBg = theme_settings?.background_color ?? background_color;

  return (
    <ControlsWrapper
      data-testid="slide-controls-container"
      show
      transform="translateX(calc(50% + 16px))"
      transformOrigin="center"
      justifyContent="center"
      flexDirection="row"
      extend={({ theme }) => ({
        transform: `translateX(calc(50% + ${theme.kosmosSpacing.space4}px))`,
        bottom: `${theme.kosmosSpacing.space6}px`,
        right: '50%',
        backgroundColor: 'transparent',
        backdropFilter: 'none',
      })}
    >
      <ThemeBgSensitive themeBg={themeBg}>
        <Controls />
      </ThemeBgSensitive>
    </ControlsWrapper>
  );
};
